import { getFunctions, httpsCallable } from 'firebase/functions';

const CACHE_DURATION = 5 * 60 * 1000;
const localCache = new Map();

export async function fetchProductMetadata(url) {
  if (!url || typeof url !== 'string') {
    return { title: null, image: null, description: null, url: url || '' };
  }

  const cached = localCache.get(url);
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    console.log('📦 [productMetadata] Local cache hit:', url.substring(0, 50));
    return cached.data;
  }

  console.log('🌐 [productMetadata] Calling Cloud Function for:', url.substring(0, 70));

  try {
    const functions = getFunctions();
    const getProductMetadata = httpsCallable(functions, 'getProductMetadata');
    
    const result = await getProductMetadata({ url });
    const data = result.data;

    const response = {
      title: data.title || null,
      image: data.image || null,
      description: data.description || null,
      url: data.url || url,
      provider: data.provider || 'unknown'
    };

    localCache.set(url, { data: response, timestamp: Date.now() });
    
    if (data.title) {
      console.log(`✅ [productMetadata] Success via ${data.provider}:`, data.title?.substring(0, 50));
    } else {
      console.log('⚠️ [productMetadata] No metadata found, manual mode will trigger');
    }

    return response;

  } catch (error) {
    console.error('❌ [productMetadata] Error:', error.message);
    return {
      title: null,
      image: null,
      description: null,
      url: url,
      error: error.message,
    };
  }
}

export function clearLocalCache() {
  localCache.clear();
  console.log('🗑️ [productMetadata] Local cache cleared');
}
